import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20251215_add_component_members",
  description: "Add componentMembers hash table to track entity-component relationships",
  apply(json: any) {
    if (!json.componentMembers) {
      json.componentMembers = {};
    }
    if (json.componentMemberships !== undefined) {
      delete json.componentMemberships;
    }
    return json;
  },
};

export default migration;
